import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import toastr from 'toastr';
import SweetAlert from 'react-bootstrap-sweetalert';
import $ from 'jquery';

/* Function */
import ObjGeneral from '../../containers/function';
import Constants from '../../containers/function/constants.js';
import EventTracker from '../../containers/function/eventTracker';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as tasksManagerTabTasksActions from '../../actions/tasks_manager_tab_tasks/index';
import * as dashboardActions from '../../actions/dashboard/index.js';
import * as headerActions from '../../actions/header/index.js';

/* Components */
import TaskModal from '../../components/tasks_manager/taskModal';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../../containers/expired/index';
import HtmlPopupModal from '../../components/tasks_manager/htmlPopupModal';
import MessageWithIcon from '../../components/common/messageWithIcon';
import String from '../../components/locales';

export class TasksManagerDetail extends Component {
  constructor(props) {
    super(props);
    this.eventTracker = new EventTracker();

    this.state = {
      isAuthorized: true,
      modalHtmlPopup: false,
      modalHtmlPopupData: {
        title: null,
        htmlDetail: null
      },
      showConfirmAnnulSingle: false,
      showConfirmAnnulSingleAction: null,
      showDriverError: false,
      showDriverErrorAlias: ''
    };
    this.taskId = 0;
  }

  componentWillUnmount() {
  }

  async componentDidMount() {
    await this.props.dashboardActions.fetchDashboardSettingApi();

    // initial load APIS
    const lang = localStoreFN().getItem('lang');
    if (lang) {
      String.setLanguage(lang);
    }
    this.props.dashboardActions.handleLanguageChange(String);

    // if there is location, send information to Google Analytics
    if(this.props.location) {
      this.props.dashboardActions.trackPageRequest(this.props.location.pathname);
    }

    // validates if the user has permission to view this view
    const permits = localStoreFN().getItem('permits');
    const permit = permits ? permits.includes('task') : null;

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);

        let objData = localStoreFN().getItem(Constants.localStorage.tasksManagerDetailData);
        objData = ObjGeneral.decoderBase64(objData);
        objData = JSON.parse(objData);

        if (obj.generalSetting.views.includes('task') && objData) {
          this.taskId = objData.id;
          await this.fetchTaskById(this.taskId);
        } else {
          this.setState({ isAuthorized: false });
        }
      }
    } else {
      this.setState({ isAuthorized: false });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    let mustFetchData = false;

    // feedback of canceled deviations
    if (prevProps.annulTasks.loading == true && this.props.annulTasks.loading == false) {
      mustFetchData = true;

      if (this.props.annulTasks.status == 200) {
        toastr.options = Constants.tostrOptions;
        toastr.success(this.props.language.tasks_manager.feedback.annulSuccess, '');
      } else {
        toastr.options = Constants.tostrOptions;
        toastr.error(this.props.language.tasks_manager.feedback.annulError, '');
      }
    }

    // edited deviation feedback
    if (prevProps.saveTask.loading == true && this.props.saveTask.loading == false) {
      mustFetchData = true;

      if (this.props.saveTask.status == 200) {
        toastr.options = Constants.tostrOptions;
        toastr.success(this.props.language.tasks_manager.feedback.editSuccess,'');
        this.setState({
          showConfirmAnnulSingle: false,
          showConfirmAnnulSingleAction: null
        });
      } else if (this.props.saveTask.status != 422) {
        const { message: saveTaskMessage, status: saveTaskStatus } = this.props.saveTask;
        let errorMessage = '';

        // if there is an error in the attached files, it shows a message
        if (saveTaskStatus === 500 && saveTaskMessage.error.code === '5200') {
          errorMessage = this.props.language.error.cod5200.replace('{list-extensions}', saveTaskMessage.error.params[0]);
          errorMessage = `<br/><br/><small>${errorMessage}</small>`;
        }

        toastr.options = Constants.tostrOptions;
        toastr.error(
          `${this.props.language.tasks_manager.feedback.editError} ${errorMessage}`,
          ''
        );

        this.setState({
          showConfirmAnnulSingle: false,
          showConfirmAnnulSingleAction: null
        });
      } else if (this.props.saveTask.status == 422) {
        var invalids = $('.task-generated-content .invalidInput');
        if (invalids.length > 0) {
          invalids.get(0).scrollIntoView();
        }

        if (
          this.props.saveTask.message &&
          this.props.saveTask.message.error &&
          this.props.saveTask.message.error.params &&
          this.props.saveTask.message.error.params.find(param => param.messageCode == 18202)
        ) {
          var error = this.props.saveTask.message.error.params.find(param => param.messageCode == 18202);
          var extraData = error && error.extraData ? error.extraData.find(data => data.key == 'PersonAlias') : null

          this.setState({
            showDriverError: true,
            showDriverErrorAlias: extraData ? extraData.value : ''
          });
        }
      }
    }

    // check if data must be fetched and if the task ID is greater than 0
    if (mustFetchData && this.taskId > 0) {
      mustFetchData = false;
      await this.fetchTaskById(this.taskId);
    }
  }

  fetchTaskById = async (taskId) => {
    await this.props.actions.fetchTasksManagerTaskApi({ id: taskId });
  };

  handleModalSlide = e => {
    var toHide = $('.slide-panel.show');
    var toShow = $('.slide-panel.hide');

    toHide.addClass('hide');
    toHide.removeClass('show');

    toShow.addClass('show');
    toShow.removeClass('hide');
  };

  handleOnChangeFormValue = e => {
    var targetId = e.target.id;
    var targetValue = e.target.value;

    if (e.target.files) {
      targetValue = e.target.files;
    } else if (e.target.dataset.groupid) {
      targetId = e.target.dataset.groupid;
      var groupValues = JSON.parse(e.target.dataset.groupvalue);
      if (e.target.checked) {
        groupValues.push(targetValue);
      } else {
        var newGroupValues = [];
        for (var i = 0; i < groupValues.length; i++) {
          if (groupValues[i] != targetValue) {
            newGroupValues.push(groupValues[i]);
          }
        }
        groupValues = newGroupValues;
      }
      targetValue = JSON.stringify(groupValues);
    }
    this.props.actions.handleChangeFormValue(targetId, targetValue);
  };

  handleModalHtmlPopup = async e => {
    if (e.target.dataset.close == 'ok-html-popup') {
      const reset = this.state.modalHtmlPopup ? false : true;
      this.setState({ modalHtmlPopup: reset });
      if (!reset) {
        this.setState({
          modalHtmlPopupData: {
            title: null,
            htmlDetail: null
          }
        });
      } else {
        const detail = e.target.dataset.detail;
        const title = e.target.dataset.title;

        this.setState({
          modalHtmlPopupData: {
            title: title,
            htmlDetail: detail
          }
        });
      }
    }
  };

  handleTaskActionConfirmFilter = (action) => {
    if (action == 'Annul') {
      this.setState({
        showConfirmAnnulSingle: true,
        showConfirmAnnulSingleAction: action
      });
    } else {
      this.handleTaskAction(action);
    }
  };

  handleTaskAction = async (action) => {
    action = this.state.showConfirmAnnulSingleAction ? this.state.showConfirmAnnulSingleAction : action;
    var files = [];
    var editedFields = [];
    var saveKeys = Object.keys(this.props.saveTask.datos);

    for (var i = 0; i < saveKeys.length; i++) {
      var field = this.props.saveTask.datos[saveKeys[i]];
      if (field.isEditable) {
        editedFields.push({
          key: field.key,
          value: field.type == 'File' ? null : field.value
        });
      }
      if (field.isEditable && field.type == 'File' && typeof field.value == 'object') {
        files = Object.keys(field.value).map(key => field.value[key]);
      }
    }

    var incidentDetail = {
      action: action,
      editedFields: editedFields
    };

    await this.props.actions.saveTaskApi(this.props.saveTask.id, incidentDetail, files);

    // tracks a Tasks Manager action event using Google Analytics.
    this.eventTracker.trackTasksManagerAction(action);
  };

  getOptionsEndpoint = async (fieldKey, endpoint) => {
    await this.props.actions.getFieldEnpointData({
      fieldKey: fieldKey,
      endpoint: endpoint
    });
  };

  getTaskFile = async (endpoint, filename) => {
    await this.props.actions.getTaskFile({
      endpoint: endpoint,
      filename: filename
    });
  };

  render() {
    // if the user logs in but does not have permission to see this view, displays a message on the screen
    if (!this.state.isAuthorized && this.props.setting) {
      return <Message message={this.props.language.error.noAuthorization} showFullscreen={true} />
    }

    // if the user had already logged in, but it expired, a message is displayed on the screen
    if (!this.state.isAuthorized && this.props.setting === false) {
      return (
        <div className="redirect-container-message flex align-center justify-center">
          <MessageWithIcon
            title={this.props.language.tasks_manager.redirectDetail.sessionExpiredTitle}
            message={this.props.language.tasks_manager.redirectDetail.sessionExpiredMessage}
            icon="fas fa-exclamation-triangle"
          />
        </div>
      )
    }

    // if the user is logged in and has permission to view this view, show the content
    if (this.props.setting) {
      let container = '';

      // condition performed for loading state of the view
      if (
        this.props.activeTask.loading ||
        this.props.annulTasks.loading ||
        this.props.saveTask.loading
      ) {
        container = <Loading language={this.props.language} showFullscreen={true} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.activeTask.status === 401 ||
        this.props.annulTasks.status === 401 ||
        this.props.saveTask.status === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the success application
      } else if (
        this.props.activeTask.status === 200 ||
        this.props.annulTasks.status === 200 ||
        this.props.saveTask.status === 200
      ) {
        container = (
          <div className={`${this.props.containerClassName ? this.props.containerClassName : ''} common-dashboards task-manager-container`}>
            <TaskModal
              typeTab={Constants.taskManagerTabs.TAB_TASKS}
              language={this.props.language}
              showModal={true}
              activeTask={this.props.activeTask}
              saveTask={this.props.saveTask}
              handleModalSlide={this.handleModalSlide}
              handleOnChange={this.handleOnChangeFormValue}
              handleModalHtmlPopup={this.handleModalHtmlPopup}
              handleTaskAction={this.handleTaskActionConfirmFilter}
              getOptionsEndpoint={this.getOptionsEndpoint}
              getTaskFile={this.getTaskFile}
              showFullscreen={true}
            />
            <HtmlPopupModal
              handleModal={this.handleModalHtmlPopup}
              modal={this.state.modalHtmlPopup}
              language={this.props.language ? this.props.language : ''}
              title={this.state.modalHtmlPopupData.title}
              htmlDetail={this.state.modalHtmlPopupData.htmlDetail}
            />
            {this.state.showConfirmAnnulSingle && (
              <SweetAlert
                error
                showCancel
                confirmBtnText={this.props.language.tasks_manager.annulConfirm.confirmButton}
                cancelBtnText={this.props.language.tasks_manager.annulConfirm.cancelButton}
                closeOnClickOutside={true}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                customClass="anullSingleAlert"
                title={
                  <span className="modal-title">
                    <strong>
                    {' '}
                    {this.props.language.tasks_manager.annulConfirm.questionSingle}
                    </strong>
                  </span>
                }
                onConfirm={this.handleTaskAction}
                onCancel={() => {
                  this.setState({
                    showConfirmAnnulSingle: false,
                    showConfirmAnnulSingleAction: null
                  });
                }}
              >
                <div className="tilte-modal-box">
                  {this.props.language.tasks_manager.annulConfirm.warningSingle}
                </div>
              </SweetAlert>
            )}
            {this.state.showDriverError && (
              <SweetAlert
                warning
                confirmBtnText={this.props.language.tasks_manager.driverErrorAlert.confirmButton}
                closeOnClickOutside={true}
                confirmBtnCssClass="confirm-button"
                customClass="driverErrorAlert driverErrorAlert-fullscreen"
                title={
                  <span className="modal-title">
                    <strong>
                    {' '}
                    {this.props.language.tasks_manager.driverErrorAlert.title}
                    </strong>
                  </span>
                }
                onConfirm={() => {this.setState({
                  showDriverError:false,
                  showDriverErrorAlias: ''
                });}}
                onCancel={() => {this.setState({
                  showDriverError:false,
                  showDriverErrorAlias: ''
                });}}
              >
                <div className="tilte-modal-box">
                  <p><strong>
                    {this.props.language.tasks_manager.driverErrorAlert.line1a + ' '}
                    {this.state.showDriverErrorAlias}
                    {this.props.language.tasks_manager.driverErrorAlert.line1b}
                  </strong></p>
                  <p>
                    {this.props.language.tasks_manager.driverErrorAlert.line2}
                  </p>
                  <p><strong>
                    {this.props.language.tasks_manager.driverErrorAlert.line3}
                  </strong></p>
                </div>
              </SweetAlert>
            )}
          </div>
        );
      } else if (
        this.props.activeTask.status === 500 ||
        this.props.annulTasks.status === 500 ||
        this.props.saveTask.status === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} showFullscreen={true} />;
      } else {
        container = <Message message={this.props.language.error.apiError} showFullscreen={true} />;
      }

      return (
        <section>
          {container}
        </section>
      );
    } else if (this.props.setting === false) {
      // if the token expired and the settings could not be obtained, the localstorage is cleared to log in again
      localStoreFN().clear();
      return null;
    }

    return (
      <section>
        {this.props.language ? this.props.language.load.loading : ''}
      </section>
    );
  }
}
const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language,

  activeTask: state.reducer.tasksManagerTabTasks.activeTask,
  saveTask: state.reducer.tasksManagerTabTasks.saveTask,
  annulTasks: state.reducer.tasksManagerTabTasks.annulTasks,
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tasksManagerTabTasksActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch)
});
TasksManagerDetail.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksManagerDetail);



// WEBPACK FOOTER //
// ./source/client/containers/tasks_manager_detail/index.jsx